const SITE_URL = 'https://mobifixpro.net';
const MANAGED_ATTR = 'data-seo-managed';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-cover.svg`;
const DEFAULT_OG_IMAGE_ALT = 'MobiFIX PRO — ремонт телефонів у Харкові';

function upsertMeta(name, content, attr = 'name') {
  if (!content) return;

  let node = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!node) {
    node = document.createElement('meta');
    node.setAttribute(attr, name);
    document.head.appendChild(node);
  }

  node.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;

  let node = document.head.querySelector(`link[rel="${rel}"]`);
  if (!node) {
    node = document.createElement('link');
    node.setAttribute('rel', rel);
    document.head.appendChild(node);
  }

  node.setAttribute('href', href);
}

function clearManagedJsonLd() {
  document.head
    .querySelectorAll(`script[${MANAGED_ATTR}="jsonld"]`)
    .forEach((node) => node.remove());
}

function addJsonLd(payload) {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.setAttribute(MANAGED_ATTR, 'jsonld');
  script.textContent = JSON.stringify(payload);
  document.head.appendChild(script);
}

export function absoluteUrl(path = '/') {
  if (/^https?:\/\//.test(path)) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

export function applySeo({
  title,
  description,
  keywords,
  image = DEFAULT_OG_IMAGE,
  imageAlt = DEFAULT_OG_IMAGE_ALT,
  path = '/',
  canonical,
  robots = 'index,follow',
  type = 'website',
  jsonLd = []
}) {
  const url = canonical || absoluteUrl(path);
  const finalTitle = title?.includes('MobiFIX PRO') ? title : `${title} | MobiFIX PRO`;

  document.title = finalTitle;
  upsertMeta('description', description);
  upsertMeta('author', 'MobiFIX PRO');
  upsertMeta('publisher', 'MobiFIX PRO');
  upsertMeta('application-name', 'MobiFIX PRO');
  upsertMeta('apple-mobile-web-app-title', 'MobiFIX PRO');

  if (keywords) {
    upsertMeta('keywords', Array.isArray(keywords) ? keywords.join(', ') : keywords);
  }

  upsertMeta('robots', robots);
  upsertMeta('twitter:card', 'summary');
  upsertMeta('twitter:title', finalTitle);
  upsertMeta('twitter:description', description);
  upsertMeta('og:site_name', 'MobiFIX PRO', 'property');
  upsertMeta('og:locale', 'uk_UA', 'property');
  upsertMeta('og:title', finalTitle, 'property');
  upsertMeta('og:description', description, 'property');
  upsertMeta('og:type', type, 'property');
  upsertMeta('og:url', url, 'property');
  upsertMeta('og:image', image, 'property');
  upsertMeta('og:image:alt', imageAlt, 'property');
  upsertMeta('og:image:type', 'image/svg+xml', 'property');
  upsertMeta('og:image:width', '1200', 'property');
  upsertMeta('og:image:height', '630', 'property');
  upsertMeta('twitter:image', image);
  upsertMeta('twitter:image:alt', imageAlt);
  upsertLink('canonical', url);

  clearManagedJsonLd();
  jsonLd.filter(Boolean).forEach(addJsonLd);
}

export function localBusinessJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': ['LocalBusiness', 'RepairBusiness'],
    '@id': `${SITE_URL}/#business`,
    name: 'MobiFIX PRO',
    url: SITE_URL,
    logo: `${SITE_URL}/logo-wordmark.svg`,
    image: `${SITE_URL}/og-cover.svg`,
    telephone: '+380682772822',
    email: 'info@mobifixpro.net',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'просп. Ювілейний, 57а',
      addressLocality: 'Харків',
      addressRegion: 'Харківська область',
      addressCountry: 'UA'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '49.9974233',
      longitude: '36.3409755'
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '09:00',
        closes: '19:00'
      }
    ],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '5',
      reviewCount: '3',
      bestRating: '5'
    },
    sameAs: [
      'https://www.facebook.com/mobifixpro',
      'https://www.instagram.com/mobifixpro',
      'https://t.me/mobifixpro'
    ],
    priceRange: '₴₴',
    slogan: 'Швидкий ремонт телефонів у Харкові'
  };
}
